import { useTypedQuery } from "hooks";
import { PrivacyAndSecurityQueryKeys } from "modules/PrivacyAndSecurityDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const usePrivacyAndSecurityStatusQuery = (dealer_id?: number) =>
  useTypedQuery({
    queryKey: PrivacyAndSecurityQueryKeys.status,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { dealer_id }, baseUrl)).data,
    enabled: false,
    refetchOnDependencies: [dealer_id]
  });
